import React, { Component } from "react";
import { toast } from "react-toastify";
import "./reporte.css";

import { getReportes } from "../../../service/api";
import SpinnerModal from "../../spiner/SpinnerModal";

class ReportesModal extends Component {
    state = {
        reportes: [],
        busy: false,
        cargandoLista: false,

        // Nuevo: ordenamiento
        sortKey: "idestatus",
        sortDirection: "asc",
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.show && this.props.show) {
            this.cargarReportes();
        }
    }

    cargarReportes = async () => {
        this.setState({ cargandoLista: true });

        try {
            const resp = await getReportes();

            const lista = Array.isArray(resp?.data)
                ? resp.data
                : Array.isArray(resp)
                    ? resp
                    : [];

            const listaOrdenada = [...lista].sort((a, b) => {
                const estatusA = Number(a?.idestatus || 0);
                const estatusB = Number(b?.idestatus || 0);

                // Pendiente primero
                if (estatusA === 1 && estatusB !== 1) return -1;
                if (estatusA !== 1 && estatusB === 1) return 1;

                // Después resueltos
                if (estatusA === 2 && estatusB !== 2) return -1;
                if (estatusA !== 2 && estatusB === 2) return 1;

                return 0;
            });

            this.setState({
                reportes: listaOrdenada,
                sortKey: "idestatus",
                sortDirection: "asc",
            });
        } catch (error) {
            console.error(error);
            toast.error("No se pudo cargar la lista de reportes");
        } finally {
            this.setState({ cargandoLista: false });
        }
    };

    formatoFecha = (fecha) => {
        if (!fecha) return "";

        const meses = [
            "Ene", "Feb", "Mar", "Abr", "May", "Jun",
            "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"
        ];

        const partes = String(fecha).split("-");
        if (partes.length !== 3) return fecha;

        const [yyyy, mm, dd] = partes;

        const mesIndex = Number(mm) - 1;
        const mesTexto = meses[mesIndex];

        if (!mesTexto) return fecha;

        return `${dd}-${mesTexto}-${yyyy}`;
    };

    getEstatusTexto = (idestatus) => {
        const estatus = Number(idestatus);

        if (estatus === 1) return "Pendiente";
        if (estatus === 2) return "Resuelto";

        return "Sin estatus";
    };

    getEstatusClass = (idestatus) => {
        const estatus = Number(idestatus);

        if (estatus === 1) return "reportes-status--pendiente";
        if (estatus === 2) return "reportes-status--resuelto";

        return "reportes-status--default";
    };

    // Nuevo: convierte fecha yyyy-mm-dd a número para ordenar bien
    getFechaValue = (fecha) => {
        if (!fecha) return 0;

        const partes = String(fecha).split("-");
        if (partes.length !== 3) return 0;

        const [yyyy, mm, dd] = partes;

        const fechaValue = new Date(
            Number(yyyy),
            Number(mm) - 1,
            Number(dd)
        ).getTime();

        return Number.isNaN(fechaValue) ? 0 : fechaValue;
    };

    // Nuevo: obtiene el valor según la columna
    getSortValue = (item, key) => {
        if (key === "idticket") {
            return Number(item?.idticket || 0);
        }

        if (key === "reporte") {
            return String(item?.reporte || "").toLowerCase();
        }

        if (key === "idestatus") {
            return Number(item?.idestatus || 0);
        }

        if (key === "fecha_transito") {
            return this.getFechaValue(item?.fecha_transito);
        }

        return "";
    };

    // Nuevo: click en header
    ordenarPor = (key) => {
        this.setState((prev) => {
            const sameColumn = prev.sortKey === key;
            const nextDirection = sameColumn && prev.sortDirection === "asc"
                ? "desc"
                : "asc";

            const reportesOrdenados = [...prev.reportes].sort((a, b) => {
                const valueA = this.getSortValue(a, key);
                const valueB = this.getSortValue(b, key);

                if (typeof valueA === "number" && typeof valueB === "number") {
                    return nextDirection === "asc"
                        ? valueA - valueB
                        : valueB - valueA;
                }

                return nextDirection === "asc"
                    ? String(valueA).localeCompare(String(valueB), "es", { numeric: true })
                    : String(valueB).localeCompare(String(valueA), "es", { numeric: true });
            });

            return {
                reportes: reportesOrdenados,
                sortKey: key,
                sortDirection: nextDirection,
            };
        });
    };

    // Nuevo: icono de ordenamiento
    renderSortIcon = (key) => {
        const { sortKey, sortDirection } = this.state;

        if (sortKey !== key) {
            return <span className="reportes-sort-icon"></span>;
        }

        return (
            <span className="reportes-sort-icon reportes-sort-icon--active">
                {sortDirection === "asc" ? "" : ""}
            </span>
        );
    };

    renderLista = () => {
        const { reportes, cargandoLista } = this.state;

        return (
            <>
                <div className="modal-body reportes-modal-body">
                    {cargandoLista ? (
                        <div className="reportes-loading-box">
                            <div className="spinner-border" role="status" />
                            <div className="mt-2">Cargando reportes...</div>
                        </div>
                    ) : (
                        <div className="reportes-table-wrap">
                            <div className="reportes-table-scroll">
                                <table className="table table-hover align-middle reportes-table">
                                    <thead>
                                        <tr>
                                            <th
                                                className="reportes-th-ticket reportes-th-sortable"
                                                onClick={() => this.ordenarPor("idticket")}
                                                title="Ordenar por ID Ticket"
                                            >
                                                <span>ID Ticket</span>
                                                {this.renderSortIcon("idticket")}
                                            </th>

                                            <th
                                                className="reportes-th-reporte reportes-th-sortable"
                                                onClick={() => this.ordenarPor("reporte")}
                                                title="Ordenar por Reporte"
                                            >
                                                <span>Reporte</span>
                                                {this.renderSortIcon("reporte")}
                                            </th>

                                            <th
                                                className="reportes-th-estatus reportes-th-sortable"
                                                onClick={() => this.ordenarPor("idestatus")}
                                                title="Ordenar por Estatus"
                                            >
                                                <span>Estatus</span>
                                                {this.renderSortIcon("idestatus")}
                                            </th>

                                            <th
                                                className="reportes-th-fecha reportes-th-sortable"
                                                onClick={() => this.ordenarPor("fecha_transito")}
                                                title="Ordenar por Fecha tránsito"
                                            >
                                                <span>Fecha tránsito</span>
                                                {this.renderSortIcon("fecha_transito")}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {reportes.length === 0 ? (
                                            <tr>
                                                <td colSpan="4">
                                                    <div className="reportes-empty-box">
                                                        No hay reportes
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            reportes.map((item) => {
                                                const isResuelto = Number(item?.idestatus) === 2;

                                                return (
                                                    <tr
                                                        key={item.idsolicitudfacturareporte}
                                                        className={isResuelto ? "reportes-row--resuelto" : ""}
                                                    >
                                                        <td className="reportes-td-ticket">
                                                            {item.idticket || ""}
                                                        </td>

                                                        <td className="reportes-td-reporte">
                                                            <div className="reporte-texto">
                                                                {item.reporte || ""}
                                                            </div>
                                                        </td>

                                                        <td className="reportes-td-estatus">
                                                            <span
                                                                className={`reportes-status ${this.getEstatusClass(item.idestatus)}`}
                                                            >
                                                                {this.getEstatusTexto(item.idestatus)}
                                                            </span>
                                                        </td>

                                                        <td className="reportes-td-fecha">
                                                            {this.formatoFecha(item.fecha_transito)}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>

                <div className="modal-footer reportes-modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary btn-fit"
                        onClick={this.props.onClose}
                    >
                        Cerrar
                    </button>
                </div>
            </>
        );
    };

    render() {
        const { show, onClose } = this.props;
        const { busy } = this.state;

        if (!show) return null;

        return (
            <>
                <SpinnerModal tipo="full" show={busy} />

                <div
                    className="modal fade show reportes-backdrop"
                    style={{
                        display: "block",
                        zIndex: 99999,
                        background: "rgba(0,0,0,.45)",
                    }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-dialog-centered reportes-modal-dialog">
                        <div className="modal-content reportes-modal-content">
                            <div className="modal-header reportes-modal-header">
                                <h5 className="modal-title">Reportes</h5>

                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={onClose}
                                    disabled={busy}
                                />
                            </div>

                            {this.renderLista()}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ReportesModal;